<script lang="ts">
	import { FullOffer, OfferForm } from "#lib/web-ui/home-buyers-template/content/index.js";
	import { getTemplateContext } from "#lib/web-ui/home-buyers-template/template-context.svelte.js";

	const templateContext = getTemplateContext();

	const pageUrl = `${templateContext.siteUrl}get-your-offer/`;
	const pageTitle = `Get Your Free Cash Offer - ${templateContext.siteName}`;
	const pageDescription = `Get a free, no-obligation cash offer on your home today. ${templateContext.siteName} can close in as little as 7 days with no fees or commissions. Start now!`;
</script>

<svelte:head>
	<title>{pageTitle}</title>
	<meta name="description" content={pageDescription} />

	<!-- Open Graph -->
	<meta property="og:type" content="website" />
	<meta property="og:title" content={pageTitle} />
	<meta property="og:description" content={pageDescription} />
	<meta property="og:url" content={pageUrl} />
</svelte:head>

<FullOffer>
	<OfferForm />
</FullOffer>
